import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Storage(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Storage", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.2211 5.31804 7.91071 14.9953c-.16797.1062-.30635.2531-.40224.4272-.0959.174-.14619.3695-.1462.5682v26.8734h6.06423v-20.525h21.147v20.5251h6.0642V15.9973c0-.2004-.0511-.3975-.1485-.5726-.0975-.1751-.238-.3225-.4083-.4281L24.4711 5.3127c-.1879-.11653-.4047-.17783-.6258-.17689-.221.00095-.4373.0641-.6242.18223Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.5975 19.1906h-7.1942c-.1388-.0001-.272-.0552-.3701-.1534-.0982-.0982-.1533-.2313-.1533-.3701v-1.8374c0-.2892.2344-.5235.5234-.5235h7.1942c.2891 0 .5235.2343.5235.5235v1.8374c0 .2891-.2344.5235-.5235.5235Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M7.36227 40.1431h6.06423v2.721H7.36227v-2.721Zm27.21123 0h6.0642v2.721h-6.0642v-2.721Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.dark, d: "M17 36h7v6h-7zm8 0h7v6h-7zm-4-6h7v5h-7z" })
  ] });
}
Storage.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Storage"
};
validateTidalLicense();
export {
  Storage
};
//# sourceMappingURL=Storage.js.map
